import {TextStyle, View, ViewStyle} from 'react-native';
import React from 'react';
import {useStyles} from '../../../hooks/styles';
import {Text} from '../../text';

export const VisuallyImpairedGroup = ({
  label,
  children,
  style = {},
  labelStyle = {},
}: React.PropsWithChildren<{label: string; labelStyle?: TextStyle; style?: ViewStyle}>) => {
  const styles = useStyles(({theme, isDesktop}) => ({
    settingContainer: {},
    settingLabel: {
      color: isDesktop ? '#000000' : theme.color.labelText,
      marginBottom: 12,
      fontFamily: 'Arial',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 16,
      lineHeight: 18,
      letterSpacing: 0,
    },
  }));
  return (
    <View style={[styles.settingContainer, style]}>
      <Text style={[styles.settingLabel, labelStyle]}>{label}</Text>
      {children}
    </View>
  );
};
